import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "./../graphql/mutations";
import * as queries from "./../graphql/queries";
import moment from "moment-timezone";
import * as PreQuestions from "./PreQuestions";
import _ from "lodash";
export class Booking {
  constructor() {}

  static async getEvent(code) {
    let date = moment();
    date = date.subtract(1, "days");
    const eventByCode = /* GraphQL */ `
      query EventByCode(
        $sortDirection: ModelSortDirection
        $filter: ModelEventFilterInput
        $limit: Int
        $nextToken: String
      ) {
        eventByCode(
          code: "${code}"
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            eventCompany {
              id
              name
              logo
            }
            id
            name
            code
            message
            description
            type
            iCalendar
            bloodDropStart
            bloodDropEnd
            urinePotLocation
            commsLink
            preQuestionTemplate
            registerInterest
            notifyRegisterInterest
            eventLocation(limit: 1000, filter: { isDeleted: { eq: 0 } }) {
              items {
                id
                addressLine1
                postcode
                town
                createdAt
                eventSlotGroup(limit: 1000, filter: { isDeleted: { eq: 0 }, active: { eq: true }, date: { gt: "${date.toISOString()}" }}) {
                  items {
                    id
                    room
                    createdAt
                    date
                    capacity
                    eventSlot(limit: 1000) {
                      items {
                        id
                        length
                        time
                        type
                        booked
                        eventBooking(limit: 1) {
                          items {
                            id
                            isDeleted
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            eventCollectUserData(filter: { isDeleted: { eq: 0 } }) {
              items {
                id
                label
                questionType
                validation
                fieldType
                internalUse
                createdAt
                isDeleted
                success
                error
                hint
                eventCollectUserDataOptions {
                  items {
                    id
                    options
                  }
                }
              }
            }
          }
          nextToken
        }
      }
    `;

    const eventObj = await API.graphql({
      query: eventByCode,
      variables: {
        // code: code,
        filter: {
          status: { eq: "Live" },
          isDeleted: { eq: 0 }
        }
      },
      authMode: "API_KEY"
    });

    // Check array has all elements needed
    let valid = false;
    eventObj.data.eventByCode.items.map(event => {
      event.eventLocation.items.map(location => {
        location.eventSlotGroup.items.map(() => {
          valid = true;
        });
      });
    });
    return valid ? eventObj.data.eventByCode.items : false;
  }

  static async getEventWithAllBookings(code) {
    const eventByCode = /* GraphQL */ `
      query EventByCode(
        $sortDirection: ModelSortDirection
        $filter: ModelEventFilterInput
        $limit: Int
        $nextToken: String
      ) {
        eventByCode(
          code: "${code}"
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            eventCompany {
              id
              name
              logo
            }
            id
            name
            code
            message
            description
            type
            iCalendar
            bloodDropStart
            bloodDropEnd
            urinePotLocation
            commsLink
            preQuestionTemplate
            registerInterest
            notifyRegisterInterest
            eventLocation(limit: 1000, filter: { isDeleted: { eq: 0 } }) {
              items {
                id
                addressLine1
                postcode
                town
                createdAt
                eventSlotGroup(limit: 1000, filter: { isDeleted: { eq: 0 }, active: { eq: true } }) {
                  items {
                    id
                    room
                    createdAt
                    date
                    capacity
                    eventSlot(limit: 1000) {
                      items {
                        id
                        length
                        time
                        type
                        booked
                        eventBooking(limit: 1) {
                          items {
                            id
                            firstname
                            lastname
                            email
                            customData
                            dob
                            isDeleted
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            eventCollectUserData(filter: { isDeleted: { eq: 0 } }) {
              items {
                id
                label
                questionType
                validation
                fieldType
                createdAt
                isDeleted
                success
                error
                hint
                eventCollectUserDataOptions {
                  items {
                    id
                    options
                  }
                }
              }
            }
          }
          nextToken
        }
      }
    `;

    const eventObj = await API.graphql({
      query: eventByCode,
      variables: {
        // code: code,
        filter: {
          status: { eq: "Live" },
          isDeleted: { eq: 0 }
        }
      },
      authMode: "API_KEY"
    });

    // Check array has all elements needed
    let valid = false;
    eventObj.data.eventByCode.items.map(event => {
      event.eventLocation.items.map(location => {
        location.eventSlotGroup.items.map(() => {
          valid = true;
        });
      });
    });
    return valid ? eventObj.data.eventByCode.items : false;
  }

  static async getEventById(id) {
    const getEvent = /* GraphQL */ `
      query GetEvent($id: ID!) {
        getEvent(id: $id) {
          eventCompany {
            id
            name
          }
          id
          name
          code
          status
          type
          iCalendar
          attendance
          eventLocation {
            items {
              id
              addressLine1
              postcode
              town
              createdAt
              eventSlotGroup {
                items {
                  id
                  room
                  createdAt
                  date
                  capacity
                  eventSlot {
                    items {
                      id
                      length
                      time
                      type
                      booked
                      eventBooking {
                        items {
                          id
                          firstname
                          lastname
                          email
                          mobile
                          dob
                          attendance
                          customData
                          isDeleted
                        }
                      }
                    }
                  }
                }
              }
            }
            nextToken
          }
          eventCollectUserData {
            items {
              id
              label
              validation
              fieldType
              createdAt
              isDeleted
              eventCollectUserDataOptions {
                items {
                  id
                  options
                }
              }
            }
            nextToken
          }
        }
      }
    `;
    const { data: events } = await API.graphql(
      graphqlOperation(getEvent, {
        id: id
      })
    );
    return events.getEvent;
  }

  static async checkAvailability(event) {
    if (!event.registerInterest || !event.notifyRegisterInterest) {
      return true;
    }

    // Check availability
    let availability = false;
    event.eventLocation.items.forEach(function(location) {
      if (location.eventSlotGroup.items) {
        location.eventSlotGroup.items.forEach(function(slotGroup) {
          if (slotGroup.eventSlot.items) {
            slotGroup.eventSlot.items.forEach(function(slot) {
              if (slot.type === "SLOT") {
                if (slot.eventBooking.items.length === 0) {
                  availability = true;
                }
              }
              if (slot.type === "workshop") {
                if (slot.booked < slotGroup.capacity) {
                  availability = true;
                }
              }
            });
          }
        });
      }
    });

    if (!availability) {
      const getEvent = /* GraphQL */ `
        query GetEvent($id: ID!) {
          getEvent(id: $id) {
            id
            code
            isDeleted
            status
          }
        }
      `;
      const {
        data: { getEvent: getRegisterInterestEvent }
      } = await API.graphql({
        query: getEvent,
        variables: { id: event.registerInterest },
        authMode: "API_KEY"
      });

      if (
        getRegisterInterestEvent.isDeleted === 0 &&
        getRegisterInterestEvent.status === "Live"
      ) {
        if (event.notifyRegisterInterest === "redirect") {
          window.location = `/booking/${getRegisterInterestEvent.code.toLowerCase()}`;
        }
        return `This event is currently fully booked, you can register your interest for further events by visiting www.healthyevents.co.uk and entering event code ${getRegisterInterestEvent.code.toLowerCase()}`;
      }
    }
    return true;
  }

  static bookingSteps(customFields, preQuestionTemplate) {
    let step = 0;
    let steps = {};

    steps.fluQuestions = {
      title: "",
      active: false,
      step: 0
    };
    steps.covidQuestions = {
      title: "",
      active: false,
      step: 0
    };

    if (preQuestionTemplate) {
      preQuestionTemplate.forEach(function(template) {
        step++;
        steps[template] = {
          title: PreQuestions[template].title,
          active: true,
          step: step
        };
      });
    }

    const preQuestions = customFields.filter(
      field => field.questionType === "PREQUESTION"
    );
    steps.premilinary = {
      title: "",
      active: false,
      step: 0
    };
    if (preQuestions.length > 0) {
      step++;
      steps.premilinary = {
        title: "Preliminary questions",
        active: true,
        step: step
      };
    }

    if (preQuestions.length > 0) {
      step++;
      steps.slots = {
        title: "Select time",
        active: true,
        step: step++
      };

      steps.contactdetails = {
        title: "Contact details",
        active: true,
        step: step++
      };

      steps.preassessment = {
        title: "Complete",
        active: true,
        step: step++
      };
    } else {
      steps.premilinary = {
        title: "",
        active: false,
        step: step++
      };

      steps.slots = {
        title: "Select location, date and time",
        active: true,
        step: step++
      };

      steps.contactdetails = {
        title: "Enter contact details",
        active: true,
        step: step++
      };

      steps.preassessment = {
        title: "Pre-assessment questions",
        active: true,
        step: step++
      };
    }
    return steps;
  }

  static async createBookingWorkshop({
    firstname,
    lastname,
    email,
    mobile,
    dob,
    capacity,
    customData,
    startTime,
    eventBookingEventSlotId
  }) {
    let input = {
      firstname: firstname.trim(),
      lastname: lastname.trim(),
      email: email.trim(),
      dob: dob,
      customData: JSON.stringify(customData),
      eventSlot: eventBookingEventSlotId,
      startTime: startTime,
      capacity: capacity
    };

    if (mobile) {
      input.mobile = mobile;
    }

    const processBookingWorkshopQL = `mutation ProcessBookingWorkshop(
      $input: CreateBookingWorkshopInput!
    ) {
      processBookingWorkshop(input: $input){
        id
        firstname
        lastname
        email
        mobile
        dob
        customData
        createdAt
        twentyFourHourReminder
        fortyEightHourReminder
        searchField
        isDeleted
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
          eventSlotGroup {
            id
            room
            date
            createdAt
            isDeleted
            assignedTo
            eventLocation {
              event {
                name
                commsTemplate
                commsLink
                iCalendar
                preQuestionTemplate
                eventCompany {
                  name
                }
              }
            }
          } 
        }
      }
    }`;

    try {
      // success
      const bookingResult = await API.graphql({
        query: processBookingWorkshopQL,
        variables: {
          input
        },
        authMode: "API_KEY"
      });
      const {
        data: { processBookingWorkshop }
      } = bookingResult;
      const {
        data: {
          processBookingWorkshop: { eventSlot }
        }
      } = bookingResult;
      const {
        data: {
          processBookingWorkshop: {
            eventSlot: { eventSlotGroup }
          }
        }
      } = bookingResult;
      const {
        data: {
          processBookingWorkshop: {
            eventSlot: {
              eventSlotGroup: { eventLocation }
            }
          }
        }
      } = bookingResult;
      const {
        data: {
          processBookingWorkshop: {
            eventSlot: {
              eventSlotGroup: {
                eventLocation: { event }
              }
            }
          }
        }
      } = bookingResult;
      const {
        data: {
          processBookingWorkshop: {
            eventSlot: {
              eventSlotGroup: {
                eventLocation: {
                  event: { eventCompany }
                }
              }
            }
          }
        }
      } = bookingResult;

      let booking = {
        firstname: processBookingWorkshop.firstname,
        lastname: processBookingWorkshop.lastname,
        email: processBookingWorkshop.email,
        mobile: processBookingWorkshop.mobile,
        event: event,
        eventSlotGroup: eventSlotGroup,
        eventLocation: eventLocation,
        eventSlot: eventSlot,
        eventCompany: eventCompany
      };

      // booking.eventSlotGroup = booking.eventSlot.eventSlotGroup;
      // booking.event = booking.eventSlot.eventSlotGroup.eventLocation.event.name;
      // booking.commsTemplateId =
      //   booking.eventSlot.eventSlotGroup.eventLocation.event.commsTemplate;
      // booking.company =
      //   booking.eventSlot.eventSlotGroup.eventLocation.event.eventCompany.name;
      return booking;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, "err");
      return false;
    }
  }

  static async createBooking({
    firstname,
    lastname,
    email,
    mobile,
    dob,
    customData,
    startTime,
    eventBookingEventSlotId
  }) {
    let input = {
      firstname: firstname.trim(),
      lastname: lastname.trim(),
      email: email.trim(),
      dob: dob,
      customData: JSON.stringify(customData),
      startTime: startTime.toISOString(),
      eventSlot: eventBookingEventSlotId
    };

    if (mobile) {
      input.mobile = mobile;
    }

    const processingBooking = `mutation ProcessingBooking(
      $input: CreateBookingInput!
    ) {
      processBooking(input: $input){
        id
        firstname
        lastname
        email
        mobile
        dob
        customData
        createdAt
        twentyFourHourReminder
        fortyEightHourReminder
        searchField
        isDeleted
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
          eventSlotGroup {
            id
            room
            date
            createdAt
            isDeleted
            assignedTo
            eventLocation {
              event {
                name
                commsTemplate
                preQuestionTemplate
                commsLink
                iCalendar
                bloodDropStart
                bloodDropEnd
                urinePotLocation
                eventCompany {
                  name
                }
              }
            }
          } 
        }
      }
    }`;

    const updateEventSlot = `mutation UpdateEventSlot(
      $input: UpdateEventSlotInput!
      $condition: ModelEventSlotConditionInput
    ) {
      updateEventSlot(input: $input, condition: $condition) {
        id
        time
        length
        type
        booked
        createdAt
        updatedAt
        isDeleted
        eventSlotGroup {
          id
          room
          date
          createdAt
          isDeleted
          assignedTo
          eventLocation {
            event {
              name
              commsTemplate
                eventCompany {
                    name
                }
            }
          }
        } 
      }
    }
  `;

    try {
      // success
      const bookingResult = await API.graphql({
        query: processingBooking,
        variables: {
          input
        },
        authMode: "API_KEY"
      });
      const {
        data: { processBooking }
      } = bookingResult;
      const {
        data: {
          processBooking: { eventSlot }
        }
      } = bookingResult;
      const {
        data: {
          processBooking: {
            eventSlot: { eventSlotGroup }
          }
        }
      } = bookingResult;
      const {
        data: {
          processBooking: {
            eventSlot: {
              eventSlotGroup: { eventLocation }
            }
          }
        }
      } = bookingResult;
      const {
        data: {
          processBooking: {
            eventSlot: {
              eventSlotGroup: {
                eventLocation: { event }
              }
            }
          }
        }
      } = bookingResult;
      const {
        data: {
          processBooking: {
            eventSlot: {
              eventSlotGroup: {
                eventLocation: {
                  event: { eventCompany }
                }
              }
            }
          }
        }
      } = bookingResult;

      // Need to do this to trigger subscription event and make slot unavailable
      await API.graphql({
        query: updateEventSlot,
        variables: { input: { id: eventSlot.id, booked: 1 } },
        authMode: "API_KEY"
      });

      let booking = {
        firstname: processBooking.firstname,
        lastname: processBooking.lastname,
        email: processBooking.email,
        mobile: processBooking.mobile,
        event: event,
        eventSlotGroup: eventSlotGroup,
        eventLocation: eventLocation,
        eventSlot: eventSlot,
        eventCompany: eventCompany
      };
      return booking;
    } catch (err) {
      return false;
    }
  }

  static async updateBooking({
    id,
    firstname,
    lastname,
    email,
    mobile,
    dob,
    isDeleted,
    eventBookingEventSlotId,
    customData
  }) {
    const bookingResult = await API.graphql({
      query: mutations.updateEventBooking,
      variables: {
        input: {
          id: id,
          firstname: firstname,
          lastname: lastname,
          email: email,
          mobile: mobile,
          dob: dob,
          customData: JSON.stringify(customData),
          isDeleted: isDeleted,
          eventBookingEventSlotId: eventBookingEventSlotId
        }
      },
      authMode: "AMAZON_COGNITO_USER_POOLS"
    });
    const booking = bookingResult.data.updateEventBooking;

    const updateEventSlot = `mutation UpdateEventSlot(
            $input: UpdateEventSlotInput!
            $condition: ModelEventSlotConditionInput
          ) {
            updateEventSlot(input: $input, condition: $condition) {
              id
              time
              length
              type
              booked
              isDeleted
              eventSlotGroup {
                id
                room
                date
                createdAt
                isDeleted
                assignedTo
                eventLocation {
                  event {
                    name
                    commsTemplate
                    eventCompany {
                        name
                    }
                  }
                }
              } 
            }
          }
        `;

    const eventSlotResult = await API.graphql({
      query: updateEventSlot,
      variables: { input: { id: booking.eventSlot.id, booked: 1 } },
      authMode: "API_KEY"
    });

    booking.eventSlotGroup =
      eventSlotResult.data.updateEventSlot.eventSlotGroup;
    booking.event =
      eventSlotResult.data.updateEventSlot.eventSlotGroup.eventLocation.event.name;
    booking.commsTemplateId =
      eventSlotResult.data.updateEventSlot.eventSlotGroup.eventLocation.event.commsTemplate;
    booking.company =
      eventSlotResult.data.updateEventSlot.eventSlotGroup.eventLocation.event.eventCompany.name;
    return booking;
  }

  static async sendBookingEmail(input) {
    const startTime = input.slotTime.substring(0, 5);
    const endTime = input.slotTime.substring(8, 13);

    const getEventCommsTemplate = /* GraphQL */ `
      query GetEventCommsTemplate($id: ID!) {
        getEventCommsTemplate(id: $id) {
          id
          name
          emailSubject
          reminderEmailSubject
          emailTemplate
          reminderEmailTemplate
          smsReminderTemplate
          smsTemplate
          eventCommsTemplateAttachments(
            filter: { attachment: { eq: "booking" } }
          ) {
            items {
              id
              attachment
              name
              key
              isDeleted
            }
          }
          isDeleted
        }
      }
    `;

    const templates = await API.graphql({
      query: getEventCommsTemplate,
      variables: { id: input.commsTemplateId },
      authMode: "API_KEY"
    });

    let attachments = [];
    const templateAttachments =
      templates.data.getEventCommsTemplate.eventCommsTemplateAttachments.items;
    templateAttachments.forEach(function(attachment) {
      attachments.push({
        file: attachment.name,
        key: "public/" + attachment.key // eu-west-2:65d471cf-d67f-4f53-954a-3fa11331d276
      });
    });

    let emailBody = templates.data.getEventCommsTemplate.emailTemplate;
    emailBody = emailBody.replace(
      "[user_fullname]",
      input.firstname + " " + input.lastname
    );
    emailBody = emailBody.replace("[user_firstname]", input.firstname);
    emailBody = emailBody.replace("[user_surname]", input.lastname);
    emailBody = emailBody.replace("[event_name]", input.event);
    emailBody = emailBody.replace("[event_start_time]", startTime);
    emailBody = emailBody.replace("[event_end_time]", endTime);
    emailBody = emailBody.replace(
      "[event_date]",
      moment(input.eventDate).format("DD/MM/YYYY")
    );
    emailBody = emailBody.replace("[event_room_name]", input.room);
    emailBody = emailBody.replace(
      "[event_blood_start_time]",
      input.bloodDropStart
    );
    emailBody = emailBody.replace("[event_blood_end_time]", input.bloodDropEnd);
    emailBody = emailBody.replace(
      "[event_urine_pot_location]",
      input.urinePotLocation
    );
    emailBody = emailBody.replace("[event_link]", input.commsLink);

    let eventDetails =
      `<b>Date</b> ` +
      moment(input.eventDate).format("DD/MM/YYYY") +
      `<br>` +
      `<b>Event</b> ` +
      input.event +
      `<br>` +
      `<b>Room</b> ` +
      input.room +
      `<br>` +
      `<b>Start</b> ` +
      startTime +
      `<br>` +
      `<b>End</b> ` +
      endTime;

    emailBody = emailBody.replace("[event_details_table]", eventDetails);
    emailBody = emailBody.replace(/\n/g, "<br/>");

    const txtMessage =
      "Hi " +
      input.firstname +
      ", your health assessment is at " +
      startTime +
      " on " +
      moment(input.eventDate).format("DD/MM/YYYY") +
      " in " +
      input.room +
      ".  Please read your confirmation email for more details.  Call 0800 170 17777 if you have any questions.";

    const sender = "HPTeam";
    // const start = input.eventDate + "T" + startTime + ":00Z";
    // const end = input.eventDate + "T" + endTime + ":00Z";

    const tz = moment.tz.guess();
    const startObj = moment.tz(`${input.eventDate} ${startTime}`, tz);
    const endObj = moment.tz(`${input.eventDate} ${endTime}`, tz);
    // console.log(start, moment(start).tz(tz).format('Z'), startObj.toISOString(), startObj.isDST(),"start");
    // console.log(end,  moment(end).tz(tz).format('Z'), endObj.toISOString(), endObj.isDST(),"end");

    const body = {
      receiver: "", //this.internationalMobile,
      sender: sender,
      message: txtMessage,
      toAddresses: [input.email],
      body: emailBody,
      subject: templates.data.getEventCommsTemplate.emailSubject,
      source: "team@healthyperformance.co.uk",
      dst: false, //startObj.isDST(),
      startTime: startObj.toISOString(),
      endTime: endObj.toISOString(),
      company: input.company,
      event: input.event,
      iCalendar: input.iCalendar,
      attachments: attachments
    };
    try {
      const result = await API.post(
        "hpLambdaNotifyUserOfEventApi",
        "/events/sendEventEmail/",
        {
          body
        }
      );
      return result;
    } catch (err) {
      await API.graphql({
        query: mutations.createBookingError,
        variables: {
          input: {
            error: `${err}`,
            payload: JSON.stringify(body),
            browser: JSON.stringify(input.browser)
          }
        },
        authMode: "API_KEY"
      });
      return false;
    }
  }

  static async sendTextMessage(input) {
    if (!input.mobile) {
      return false;
    }

    const internationalMobile = "44" + input.mobile.replace(/^0+/, "");
    const startTime = input.slotTime.substring(0, 5);
    const endTime = input.slotTime.substring(8, 13);

    const templates = await API.graphql({
      query: queries.getEventCommsTemplate,
      variables: { id: input.commsTemplateId },
      authMode: "API_KEY"
    });

    let txtMessage = templates.data.getEventCommsTemplate.smsTemplate;
    txtMessage = txtMessage.replace(
      "[user_fullname]",
      input.firstname + " " + input.lastname
    );
    txtMessage = txtMessage.replace("[user_firstname]", input.firstname);
    txtMessage = txtMessage.replace("[user_surname]", input.lastname);
    txtMessage = txtMessage.replace("[event_start_time]", startTime);
    txtMessage = txtMessage.replace("[event_end_time]", endTime);
    txtMessage = txtMessage.replace(
      "[event_date]",
      moment(input.eventDate).format("DD/MM/YYYY")
    );
    txtMessage = txtMessage.replace("[event_name]", input.event);
    txtMessage = txtMessage.replace("[event_room_name]", input.room);

    // Send an SMS
    const numbers = [internationalMobile];

    const body = {
      message: txtMessage,
      number: numbers
    };

    API.post("hpLambdaNotifyUserOfEventApi", "/events/sendSmsMessage/", {
      body
    });
  }

  static async cancelBooking({ bookingId, slotId, iCalendar }) {
    const deleteEventBooking = `mutation DeleteEventBooking(
      $input: DeleteEventBookingInput!
      $condition: ModelEventBookingConditionInput
    ) {
      deleteEventBooking(input: $input, condition: $condition) {
        id
        firstname
        lastname
        email
        mobile
        dob
        isDeleted
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
          eventSlotGroup {
            id
            room
            date
            createdAt
            isDeleted
            eventLocation {
              id
              postcode
              event {
                id
                name
                eventCompany {
                  id
                  name
                }
              }
            }
          } 
        }
      }
    }
    `;

    const dEventBooking = await API.graphql({
      query: deleteEventBooking,
      variables: { input: { id: bookingId } },
      authMode: "API_KEY"
    });

    if (slotId) {
      const updateEventSlot = `mutation UpdateEventSlot(
        $input: UpdateEventSlotInput!
        $condition: ModelEventSlotConditionInput
      ) {
        updateEventSlot(input: $input, condition: $condition) {
          id
          time
          length
          type
          booked
          isDeleted
          eventSlotGroup {
            id
            room
            date
            createdAt
            isDeleted
            assignedTo
            eventLocation {
              event {
                name
                  eventCompany {
                      name
                  }
              }
            }
          } 
        }
      }
    `;

      // If workshop
      let customersBookedIn = 0;
      if (dEventBooking.data.deleteEventBooking.eventSlot.type === "workshop") {
        customersBookedIn =
          dEventBooking.data.deleteEventBooking.eventSlot.booked;
        customersBookedIn--;
      }

      await API.graphql({
        query: updateEventSlot,
        variables: { input: { id: slotId, booked: customersBookedIn } },
        authMode: "API_KEY"
      });
    }

    if (dEventBooking.data.deleteEventBooking.id) {
      const eventBooking = dEventBooking.data.deleteEventBooking;

      let emailBody = `Dear [user_firstname]<br><br>
    
    Please accept this email as confirmation of your cancelled appointment.<br><br>
    
    [event_details_table]<br> 
    
    If you would like to rebook another appointment please click here: ${window.location.origin} . <br><br>
    
    Healthy regards<br><br>
    Healthy Performance Team<br>
    0800 170 1777<br>
    team@healthyperformance.co.uk<br>
    `;

      emailBody = emailBody.replace("[user_firstname]", eventBooking.firstname);

      const startTime = eventBooking.eventSlot.time.substring(0, 5);
      const endTime = eventBooking.eventSlot.time.substring(8, 13);

      let eventDetails =
        `<b>Date</b> ` +
        moment(eventBooking.eventSlot.eventSlotGroup.date).format(
          "DD/MM/YYYY"
        ) +
        `<br>` +
        `<b>Event</b> ` +
        eventBooking.eventSlot.eventSlotGroup.eventLocation.event.name +
        `<br>` +
        `<b>Room</b> ` +
        eventBooking.eventSlot.eventSlotGroup.room +
        `<br>` +
        `<b>Start</b> ` +
        startTime +
        `<br>` +
        `<b>End</b> ` +
        endTime +
        `<br>`;

      emailBody = emailBody.replace("[event_details_table]", eventDetails);
      const start =
        eventBooking.eventSlot.eventSlotGroup.date + " " + startTime;
      const end = eventBooking.eventSlot.eventSlotGroup.date + " " + endTime;

      const body = {
        toAddresses: [dEventBooking.data.deleteEventBooking.email],
        body: emailBody,
        subject: "Booking Cancellation",
        source: "team@healthyperformance.co.uk",
        company:
          eventBooking.eventSlot.eventSlotGroup.eventLocation.event.eventCompany
            .name,
        event: eventBooking.eventSlot.eventSlotGroup.eventLocation.event.name,
        dst: moment(start).isDST(),
        startTime: start,
        endTime: end,
        iCalendar: iCalendar
      };

      const result = await API.post(
        "hpLambdaNotifyUserOfEventApi",
        "/events/sendCancelBookingEmail",
        {
          body
        }
      );

      return result;
    }
  }

  static customFields(event) {
    let collectUserDatas = [];
    const rules = {
      required: v => !!v || "This field is required.",
      email: v => /.+@.+/.test(v) || "E-mail must be valid"
    };
    if (event) {
      event.eventCollectUserData.items.forEach(function(collectUserData) {
        // Validation
        let validation = [];
        // Check if custom field is only for custom use
        if (collectUserData.internalUse !== true) {
          collectUserData.validation.forEach(function(validationType) {
            if (validationType === "required") {
              validation.push(rules.required);
            }
            if (validationType === "email") {
              validation.push(rules.email);
            }
          });

          let fieldName = collectUserData.label
            .trim() //might need polyfill if you need to support older browsers
            .toLowerCase() //lower case everything
            .replace(
              /([^A-Z0-9]+)(.?)/gi, //match multiple non-letter/numbers followed by any character
              function() {
                return arguments[2].toUpperCase(); //3rd index is the character we need to transform uppercase
              }
            );

          if (collectUserData.questionType === "EMPLOYEE") {
            fieldName = "employeeNumber";
          }

          // Build custom fields
          collectUserDatas.push({
            id: collectUserData.id,
            label: collectUserData.label,
            fieldName: fieldName,
            success: collectUserData.success,
            error: collectUserData.error,
            hint: collectUserData.hint,
            questionType: collectUserData.questionType,
            fieldType: collectUserData.fieldType,
            validation: validation,
            options: []
          });

          // If select box get select options
          if (collectUserData.fieldType === "select") {
            if (collectUserData.eventCollectUserDataOptions.items.length > 0) {
              let opts = collectUserData.eventCollectUserDataOptions.items.map(
                function(option) {
                  return {
                    text: option.options,
                    value: option.options
                  };
                }
              );
              opts = _.orderBy(opts, "text", "asc");
              collectUserDatas[collectUserDatas.length - 1].options = opts;
            }
          }
        }
      });
      return collectUserDatas;
    }
  }

  static allCustomFields(event) {
    let collectUserDatas = [];
    const rules = {
      required: v => !!v || "This field is required.",
      email: v => /.+@.+/.test(v) || "E-mail must be valid"
    };
    if (event) {
      event.eventCollectUserData.items.forEach(function(collectUserData) {
        // Validation
        let validation = [];
        collectUserData.validation.forEach(function(validationType) {
          if (validationType === "required") {
            validation.push(rules.required);
          }
          if (validationType === "email") {
            validation.push(rules.email);
          }
        });

        let fieldName = collectUserData.label
          .trim() //might need polyfill if you need to support older browsers
          .toLowerCase() //lower case everything
          .replace(
            /([^A-Z0-9]+)(.?)/gi, //match multiple non-letter/numbers followed by any character
            function() {
              return arguments[2].toUpperCase(); //3rd index is the character we need to transform uppercase
            }
          );

        if (collectUserData.questionType === "EMPLOYEE") {
          fieldName = "employeeNumber";
        }

        // Build custom fields
        collectUserDatas.push({
          id: collectUserData.id,
          label: collectUserData.label,
          fieldName: fieldName,
          success: collectUserData.success,
          error: collectUserData.error,
          hint: collectUserData.hint,
          questionType: collectUserData.questionType,
          fieldType: collectUserData.fieldType,
          validation: validation,
          options: []
        });

        // If select box get select options
        if (collectUserData.fieldType === "select") {
          if (collectUserData.eventCollectUserDataOptions.items.length > 0) {
            let opts = collectUserData.eventCollectUserDataOptions.items.map(
              function(option) {
                return {
                  text: option.options,
                  value: option.options
                };
              }
            );
            opts = _.orderBy(opts, "text", "asc");
            collectUserDatas[collectUserDatas.length - 1].options = opts;
          }
        }
      });
      return collectUserDatas;
    }
  }

  static async searchBookingBySearchField({ searchQuery, nextToken }) {
    const bookingBySearchField = /* GraphQL */ `
      query BookingBySearchField(
        $searchField: String
        $sortDirection: ModelSortDirection
        $filter: ModelEventBookingFilterInput
        $limit: Int
        $nextToken: String
      ) {
        bookingBySearchField(
          searchField: $searchField
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            firstname
            lastname
            email
            mobile
            attendance
            dob
            isDeleted
            eventSlot {
              id
              time
              type
              length
              booked
              eventSlotGroup {
                room
                date
                eventLocation {
                  event {
                    id
                    iCalendar
                    type
                  }
                }
              }
            }
          }
          nextToken
        }
      }
    `;

    const {
      data: { bookingBySearchField: events }
    } = await API.graphql({
      query: bookingBySearchField,
      variables: {
        searchField: searchQuery.toLowerCase(),
        nextToken: nextToken
      }
    });
    return events;
  }

  static async searchBookingByField({ filter, nextToken }) {
    const listEventBookings = /* GraphQL */ `
      query ListEventBookings(
        $filter: ModelEventBookingFilterInput
        $limit: Int
        $nextToken: String
      ) {
        listEventBookings(
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            firstname
            lastname
            email
            mobile
            dob
            customData
            createdAt
            startTime
            twentyFourHourReminder
            fortyEightHourReminder
            searchField
            isDeleted
            updatedAt
            eventSlot {
              id
              time
              length
              type
              booked
              isDeleted
              createdAt
              updatedAt
              eventSlotGroup {
                room
                date
                eventLocation {
                  event {
                    id
                    iCalendar
                    type
                  }
                }
              }
            }
          }
          nextToken
        }
      }
    `;

    const {
      data: { listEventBookings: events }
    } = await API.graphql({
      query: listEventBookings,
      variables: {
        filter,
        nextToken: nextToken
      }
    });
    return events;
  }
}
